import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Eye1Icon, Eye2Icon } from '../icons';
import { Input } from './input';
export const InputPassword = ({ size = 's', value, onChange, startContent, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);
    const renderStartContent = (label) => (_jsx(StartContent, { children: label }));
    const renderEndContent = () => {
        const Icon = showPassword ? Eye2Icon : Eye1Icon;
        return (_jsx(EndContent, { onClick: () => setShowPassword((show) => !show), children: _jsx(Icon, { width: 16, height: 16 }) }));
    };
    const onChange_ = useCallback((e) => {
        onChange?.(e.target.value);
    }, [onChange]);
    return (_jsx(Input, { value: value, onChange: onChange_, startContent: startContent ? renderStartContent(startContent) : undefined, endContent: renderEndContent(), type: showPassword ? 'text' : 'password', autoCorrect: "off", autoCapitalize: "off", spellCheck: "false", autoComplete: "new-password", size: size, ...props }));
};
const StartContent = styled.div `
  // TODO: measure startContent width and use max with + 12px as padding
  width: 70px;
`;
const EndContent = styled.div `
  color: var(--text-12);

  cursor: pointer;
  display: grid;
  place-items: center;
`;
//# sourceMappingURL=input-password.js.map